import type { Role } from '../../api/types';

export type RoleToggle = {
  nextRole: Role;
  actionLabel: string;
  canChange: boolean;
};

export function getRoleToggleForAdminPage(userRole: Role): RoleToggle | null {
  if (userRole === 'admin') {
    return { nextRole: 'organizer', actionLabel: 'Назначить организатора', canChange: false };
  }

  if (userRole === 'organizer') {
    return { nextRole: 'user', actionLabel: 'Снять организатора', canChange: true };
  }

  return { nextRole: 'organizer', actionLabel: 'Назначить организатора', canChange: true };
}
